@if (documentTypeForm()) {
<form [formGroup]="documentTypeForm()">
  <div class="form-group row mb-3">
    <label class="col-md-4 col-form-label">Nombre</label>
    <div class="col-md-8">
      <input type="text" class="form-control" formControlName="name"
        placeholder="Ej: Licencia de conducir">
      @if (documentTypeForm().get('name')?.errors?.['required'] && documentTypeForm().get('name')?.touched) {
        <div><small class="text-danger">Nombre es requerido.</small></div>
      }
    </div>
  </div>

  <div class="form-group row mb-3">
    <label class="col-md-4 col-form-label">Slug</label>
    <div class="col-md-8">
      @if (mode() === formMode.CREATE) {
        <input type="text" class="form-control text-uppercase" formControlName="slug"
          placeholder="Opcional — se genera del nombre"
          (blur)="documentTypeForm().get('slug')?.setValue(($any($event.target).value || '').toUpperCase())">
        <div class="form-text">Si se deja vacío, se genera automáticamente.</div>
      } @else {
        <strong><code>{{ documentTypeForm().get('slug')?.value }}</code></strong>
        <div class="form-text small">El slug no se edita para no romper requisitos existentes.</div>
      }
    </div>
  </div>

  <div class="form-group row mb-3">
    <label class="col-md-4 col-form-label">Nombre corto</label>
    <div class="col-md-8">
      <input type="text" class="form-control" formControlName="nameShort" placeholder="Opcional">
    </div>
  </div>

  <div class="form-group row mb-3">
    <label class="col-md-4 col-form-label">Descripción</label>
    <div class="col-md-8">
      <textarea class="form-control" rows="2" formControlName="description"
        placeholder="Opcional"></textarea>
    </div>
  </div>

  <div class="form-group row mb-3">
    <label class="col-md-4 col-form-label">Orden</label>
    <div class="col-md-8">
      <input type="number" class="form-control" formControlName="order">
    </div>
  </div>

  <div class="form-group row mb-3">
    <label class="col-md-4 col-form-label">Vencimiento</label>
    <div class="col-md-8 d-flex align-items-center">
      <div class="form-check form-switch mb-0">
        <input class="form-check-input" type="checkbox" role="switch"
          formControlName="allowExpiration" id="doc-type-expire">
        <label class="form-check-label" for="doc-type-expire">
          Requiere fecha de vencimiento
        </label>
      </div>
    </div>
  </div>
  <div class="form-group row mb-1">
    <label class="col-md-4 col-form-label">Activo</label>
    <div class="col-md-8 d-flex align-items-center">
      <div class="form-check form-switch mb-0">
        <input class="form-check-input" type="checkbox" role="switch"
          formControlName="isActive" id="doc-type-active">
        <label class="form-check-label" for="doc-type-active">
          {{ documentTypeForm().get('isActive')?.value ? 'Disponible en requisitos' : 'Inactivo (no se solicita)' }}
        </label>
      </div>
    </div>
  </div>
</form>
}
